<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <b-col sm="12">
        <h4 style="text-align: center">
          20. BENEFICIOS PRIVADOS
        </h4>
      </b-col>

      <b-list-group sm="12">
        <b-list-group-item
          v-for="(item, index) in beneficiosPrivados.beneficio"
          :key="index"
        >
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>
          <b-col md="12">
            <h5 style="text-align: center">Beneficio Privado</h5>
          </b-col>
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>
          <!-- Formulario -->
          <b-col md="12">
            <b-row>
              <b-col sm="2">
                <b-form-group>
                  <label>Tipo Operación:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosBeneficios[index].cambios = true"
                    v-model="item.tipoOperacion"
                    :options="tipoOperacion"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label>Tipo Beneficio:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    class="mb-3"
                    v-model="item.tipoBeneficio.clave"
                    :options="tipoBeneficio"
                    text-field="valor"
                    value-field="clave"
                    @change="seleccionaValorBeneficio(index)"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label>Tipo de Persona:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosBeneficios[index].cambios = true"
                    v-model="item.otorgante.tipoPersona"
                    :options="tipoPersona"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group>
                  <label>Nombre Razón Social:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosBeneficios[index].cambios = true"
                    type="text"
                    v-model="item.otorgante.nombreRazonSocial"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>RFC:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosBeneficios[index].cambios = true"
                    type="text"
                    v-model="item.otorgante.rfc"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="8">
                <b-form-group>
                  <label>Especificación de Beneficio:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosBeneficios[index].cambios = true"
                    type="text"
                    v-model="item.especifiqueBeneficio"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <label>Forma Recepción:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    v-model="item.formaRecepcion"
                    :options="formaRecepcion"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group>
                  <label>Monto Mensual:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    @change="cambiosBeneficios[index].cambios = true"
                    type="text"
                    v-model="item.montoMensualAproximado.valor"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="1">
                <b-form-group>
                  <label>Moneda:</label>
                  <b-form-input
                    type="text"
                    v-model="item.montoMensualAproximado.moneda"
                    placeholder="MXN"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="2">
                <b-form-group>
                  <label>Sector:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    class="mb-3"
                    v-model="item.sector.clave"
                    :options="sector"
                    text-field="valor"
                    value-field="clave"
                    @change="seleccionaSectorValor(index)"
                  />
                </b-form-group>
              </b-col>

              <br />

            
            </b-row>
          </b-col>
          <br />
          <!-- FIN formulario -->

          <hr />
           <b-col md="12">
            <b-col md="12">
              <h6>Beneficiarios:</h6>
            </b-col>

            <b-list-group sm="12">
              <b-list-group-item
                v-for="(item, i) in beneficiosPrivados.beneficio[
                  index
                ].beneficiario"
                :key="i"
              >
                <p style="text-align: center">{{ item.valor }}</p>
                <b-row style="text-align: center">
                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="danger"
                      size="sm"
                      @click="eliminarBeneficiario(index)"
                      >Eliminar beneficiario</b-button
                    >
                  </b-col>
                </b-row>
              </b-list-group-item>
              <br />
              <b-modal
              :disabled="status === 'Concluida'"
                v-model="mostrar"
                title="Nuevo beneficiario"
                cancel-title="Cancelar"
                ok-title="Generar"
                @ok="agregarBeneficiario(index)"
              >
                <b-form-select
                  v-model="tmpBeneficiario"
                  :options="b"
                ></b-form-select>
              </b-modal>
            </b-list-group>
            <b-col md="12" >
              <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="mostrar = true"
                >Agregar Beneficiario</b-button
              >
            </b-col>
          </b-col>
          
           <br />
 
          <hr />
          <br />
            <b-col md="12">
                <b-row style="text-align: center">
                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="primary"
                      size="sm"
                      @click="guardarBeneficio(index)"
                      >Guardar Beneficio</b-button
                    >
                    <p
                      v-if="cambiosBeneficios[index].cambios"
                      class="error-text"
                    >
                      <i>No se han guardado los cambios</i>
                    </p>
                  </b-col>

                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="danger"
                      size="sm"
                      @click="eliminarBeneficio(index)"
                      >Eliminar Beneficio</b-button
                    >
                  </b-col>
                </b-row>
              </b-col>
      
   
    <br />
 
         </b-list-group-item>
      </b-list-group>

        </b-row>
         <br />
      <b-row>
      <b-col md="12">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="nuevoBeneficio()"
          >Agregar Beneficio</b-button
        >
      </b-col>
    </b-row>
        <br />
    <!--ACLARACIONES-->
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label>Aclaraciones observaciones:</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            type="text"
            @change="cambios = true"
            v-model="beneficiosPrivados.aclaracionesObservaciones"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br />
    <br />
    <b-row>
      <b-col md="4">
        <b-button  variant="success" @click="verSeccion(0)" :disabled="enviando"
          >Regresar al índice</b-button
        >
      </b-col>

      <b-col md="4" style="text-align: center">
        <b-button
        v-if="status !== 'Concluida'"
          variant="primary"
          @click="actualizarObservaciones()"
          :disabled="enviando"
          >Guardar cambios</b-button
        >
        <br />
        <p v-if="cambios" class="error-text">
          <i>No se han guardado los cambios</i>
        </p>
      </b-col>

      <b-col md="2">
        <b-button
          variant="secondary"
          @click="verSeccion(19)"
          :disabled="enviando"
          >Anterior</b-button
        >
      </b-col>
      <b-col md="2">
        <b-button
            class="pull-right"
          variant="secondary"
          @click="verSeccion(21)"
          :disabled="enviando"
          >Siguiente</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  components: { Loader, Datetime },
  props: ["beneficiosPrivados", "status"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  data: function() {
    return {
      titulo: this.$route.name,
      contador: 0,
      cambiosBeneficios: [],
      enviando: false,
      cambios: false,
      tipoOperacion: ["AGREGAR", "MODIFICAR", "SIN_CAMBIOS", "BAJA"],
      tipoBeneficio: [
        { clave: "S", valor: "SORTEO" },
        { clave: "C", valor: "CONCURSO" },
        { clave: "D", valor: "DONACIÓN" },
        { clave: "O", valor: "OTRO" }
      ],
      tipoPersona: ["FISICA", "MORAL"],
      formaRecepcion: ["MONETARIO", "ESPECIE"],
      sector: [
        { clave: "AGRI", valor: "AGRICULTURA" },
        { clave: "MIN", valor: "MINERÍA" },
        { clave: "EELECT", valor: "ENERGÍA ELÉCTRICA" },
        { clave: "CONS", valor: "CONSTRUCCIÓN" },
        { clave: "INDMANU", valor: "INDUSTRIA MANUFACTURERA" },
        { clave: "CMAYOR", valor: "COMERCIO AL POR MAYOR" },
        { clave: "CMENOR", valor: "COMERCIO AL POR MENOR" },
        { clave: "TRANS", valor: "TRANSPORTE" },
        { clave: "MEDIOM", valor: "MEDIOS MASIVOS" },
        { clave: "SERVFIN", valor: "SERVICIOS FINANCIEROS" },
        { clave: "SERVPROF", valor: "SERVICIOS PROFESIONALES" },
        { clave: "SERVINM", valor: "SERVICIOS INMOBILIARIOS" },
        { clave: "SERVCORP", valor: "SERVICIOS CORPORATIVOS" },
        { clave: "SERVS", valor: "SERVICIOS DE SALUD" },
        { clave: "SERVESPAR", valor: "SERVICIOS DE ESPARCIMIENTO" },
        { clave: "SERVALOJ", valor: "SERVICIOS DE ALOJAMIENTO" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      beneficiario: [
        { clave: "DC", valor: "DECLARANTE" },
        { clave: "CY", valor: "CONYUGE" },
        { clave: "CON", valor: "CONCUBINA O CONCUBINARIO" },
        { clave: "CONV", valor: "CONVIVIENTE" },
        { clave: "HIJ", valor: "HIJO(A)" },
        { clave: "HER", valor: "HERMANO(A)" },
        { clave: "CU", valor: "CUÑADO(A)" },
        { clave: "MA", valor: "MADRE" },
        { clave: "PA", valor: "PADRE" },
        { clave: "TIO", valor: "TIO (A)" },
        { clave: "PRI", valor: "PRIMO" },
        { clave: "SOB", valor: "SOBRINO (A)" },
        { clave: "AHI", valor: "AHIJADO(A)" },
        { clave: "NUE", valor: "NUERA" },
        { clave: "YER", valor: "YERNO" },
        { clave: "ABU", valor: "ABUELO(A)" },
        { clave: "NIE", valor: "NIETO(A)" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      b: ["DECLARANTE","CONYUGE" ,"CONCUBINA O CONCUBINARIO" ,"CONVIVIENTE" ,"HIJO(A)" , "HERMANO(A)" ,"CUÑADO(A)","MADRE","TIO (A)" ,"PRIMO" ,"SOBRINO (A)" , "AHIJADO(A)" ,"NUERA" ,"YERNO" ,"ABUELO(A)" ,"NIETO(A)" ,"OTRO" 
      ],
      tmpBeneficiario: "",
      mostrar: false
    };
  },
  methods: {
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },
    actualizarObservaciones() {
      this.enviando = true;

      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/beneficiosPrivados/" +
            this.$route.params.id +
            "/aclaracionesObservaciones",

          {
            ninguno: this.beneficiosPrivados.ninguno,
            aclaracionesObservaciones: this.beneficiosPrivados
              .aclaracionesObservaciones
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
        
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambios = false;
          this.$forceUpdate();
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
       
        });
    },
    seleccionaValorBeneficio(index) {
      let indice = this.tipoBeneficio.findIndex(
        x =>
          x.clave ==
          this.beneficiosPrivados.beneficio[index].tipoBeneficio.clave
      );
      this.beneficiosPrivados.beneficio[
        index
      ].tipoBeneficio.valor = this.tipoBeneficio[indice].valor;
    },

    nuevoBeneficio() {
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/beneficiosPrivados/" +
            this.$route.params.id +
            "/beneficio",
          {},
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
    

          let objeto = { _id: this.contador, cambios: false };
          this.cambiosBeneficios.push(objeto);
          //VERIFICAR
          this.beneficiosPrivados.beneficio.push(res.data.beneficio);
          this.contador++;
          this.enviando = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });
    },
    guardarBeneficio(index) {
      this.enviando = true;

      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/beneficiosPrivados/" +
            this.$route.params.id +
            "/beneficio/" +
            this.beneficiosPrivados.beneficio[index]._id,
          {
            tipoOperacion: this.beneficiosPrivados.beneficio[index]
              .tipoOperacion,
            tipoBeneficioClave: this.beneficiosPrivados.beneficio[index]
              .tipoBeneficio.clave,
            tipoBeneficioValor: this.beneficiosPrivados.beneficio[index]
              .tipoBeneficio.valor,
            otorganteTipoPersona: this.beneficiosPrivados.beneficio[index]
              .otorgante.tipoPersona,
            otorganteNombreRazonSocial: this.beneficiosPrivados.beneficio[index]
              .otorgante.nombreRazonSocial,
            otorganteRFC: this.beneficiosPrivados.beneficio[index].otorgante
              .rfc,
            formaRecepcion: this.beneficiosPrivados.beneficio[index]
              .formaRecepcion,
            especifiqueBeneficio: this.beneficiosPrivados.beneficio[index]
              .especifiqueBeneficio,
            montoMensualAproximadoValor: this.beneficiosPrivados.beneficio[
              index
            ].montoMensualAproximado.valor,
            montoMensualAproximadoMoneda: this.beneficiosPrivados.beneficio[
              index
            ].montoMensualAproximado.moneda,
            sectorClave: this.beneficiosPrivados.beneficio[index].sector.clave,
            sectorValor: this.beneficiosPrivados.beneficio[index].sector.valor
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
         
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.cambiosBeneficios[index].cambios = false;
          this.$forceUpdate();
          this.enviando = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
        });
    },
    eliminarBeneficio(index) {
      swal({
        text: "¿Está seguro en eliminar el beneficio?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/beneficiosPrivados/" +
                this.$route.params.id +
                "/beneficio/" +
                this.beneficiosPrivados.beneficio[index]._id,

              { headers: { token: this.sessionToken } }
            )
            .then(res => {
            
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });

                this.beneficiosPrivados.beneficio.splice(index, 1);
                this.cambiosBeneficios.splice(index, 1);
                this.contador--;
              }

              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
              
            });
        }
      });
    },
    agregarBeneficiario(index) {
   
      let indice = this.beneficiario.findIndex(
        x => x.valor == this.tmpBeneficiario
      );
      let nuevo = {
        clave: this.beneficiario[indice].clave,
        valor: this.tmpBeneficiario
      };
     this.beneficiosPrivados.beneficio[index].beneficiario.push(nuevo);
    

      axios
        .post(
         this.httpURL +
            "/declaraciones/V2/beneficiosPrivados/" +
            this.$route.params.id +
            "/beneficio/" +
            this.beneficiosPrivados.beneficio[index]._id +
            "/beneficiario",
          {
           clave: this.beneficiario[indice].clave,
           valor: this.tmpBeneficiario
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
        
          this.banderaEditar = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });


    },
    seleccionaSectorValor(index) {
      let indice = this.sector.findIndex(
        x => x.clave == this.beneficiosPrivados.beneficio[index].sector.clave
      );
      this.beneficiosPrivados.beneficio[index].sector.valor = this.sector[
        indice
      ].valor;
    },
    seleccionaValorBeneficiario(index, i) {
      let indice = this.beneficiario.findIndex(
        x =>
          x.clave ==
          this.beneficiosPrivados.beneficio[index].beneficiario[i].clave
      );
      this.beneficiosPrivados.beneficio[index].beneficiario[
        i
      ].valor = this.beneficiario[indice].valor;
    },

   
    eliminarBeneficiario(index) {
   
      swal({
        text: "¿Está seguro en eliminar el beneficiario?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/beneficiosPrivados/" +
                this.$route.params.id +
                "/beneficio/" +
                this.beneficiosPrivados.beneficio[index]._id +
                "/beneficiario/" +
                this.beneficiosPrivados.beneficio[index].beneficiario[index]
                  ._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
           
              this.beneficiosPrivados.beneficio[index].beneficiario.splice(
                index,
                1
              );
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
             
            });
        }
      });
    }
  },
  watch: {},

  created() {
   
    this.beneficiosPrivados.beneficio.forEach(Element => {
      let objeto = { _id: Element._id, cambios: false };
      this.cambiosBeneficios.push(objeto);
      if (Element.tipoOperacion === "AGREGAR") {
        Element.tipoOperacion = "MODIFICAR";
      }
    });
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
